import { Component, OnInit } from "@angular/core";
import { FormBuilder, FormGroup } from "@angular/forms";
import { NavParams, ViewController } from "ionic-angular";
import { Observable } from "rxjs/Observable";
import { EmailProvider } from "../../../../providers/email";
import { GenFormBuilder } from "../../../../providers/form";
import { PaymentProvider } from "../../../../providers/payments";
import { ShopsData } from "../../../../providers/shops";
import { Utilities } from "../../../../providers/utilities";
import { JsonValidator } from "../../../../validators/json";
@Component({
  selector: "app-shops-form",
  templateUrl: "shops-form.component.html",
})

export class ShopsFormComponent implements OnInit {

  public form: FormGroup;
  public submitAttempt: boolean = false;
  public clientId: string;
  public defaultLanguage: string;
  public userData: any;
  public country$: Observable<any[]>;
  public comerce: any;
  public language: string;
  // tslint:disable-next-line:max-line-length
  public defaultTemplateEmail: string = "https://firebasestorage.googleapis.com/v0/b/rebus-v4.appspot.com/o/Templates%2FPAY_TEMPLATE_DEFAULT.html?alt=media&token=12b6a81a-3b92-4f77-9ed8-576579c9ec5f";

  constructor(
    public viewCtrl: ViewController,
    private formBuilder: FormBuilder,
    private genForm: GenFormBuilder,
    private shopsData: ShopsData,
    private navParams: NavParams,
    private emailData: EmailProvider,
    private utilities: Utilities,
    private paymentprovider: PaymentProvider,
  ) { }

  public ngOnInit() {
    this.clientId = this.navParams.get("clientId");
    this.defaultLanguage = this.navParams.get("defaultLanguage");
    this.language = this.defaultLanguage;
    this.userData = this.navParams.get("userData");
    this.comerce = this.navParams.get("comerce");
    // Esto se deja quemado por ahora mientras se pasa aproduccion el api de pagos
    this.country$ = this.paymentprovider.getCountrys();
    this.buildForm();
  }

  // public addShipping() {
  //   const modal = this.utilities.Modal.create(
  //     "ShippingAddPage",
  //     { defaultLanguage: this.clientId },
  //     { enableBackdropDismiss: false }
  //   );
  //   modal.present();
  //   modal.onDidDismiss(data => {
  //     if (data) {
  //       const oldData = this.form.get("shipping_list").value;
  //       this.form.get("shipping_list").patchValue({ ...oldData, data });
  //     }
  //   });
  // }

  public selectCountry(event) {
    if (event.result) {
      if (Object.keys(event.result).length === 1) {
        if (this.form.get("country").value !== "" && this.form.get("country").value !== Object.keys(event.result)[0]) {
          this.utilities.Alert.create({
            buttons: [{
              role: "cancel",
              text: "Cancel",
            }, {
              handler: () => this.form.get("country").setValue(Object.keys(event.result)[0]),
              text: "Ok",
            }],
            // tslint:disable-next-line:max-line-length
            message: "Remember: If you change the country of the store, you must reconfigure the VAT of the associated products",
            title: "Alert",
          }).present();
        } else {
          this.form.get("country").setValue(Object.keys(event.result)[0]);
        }
      }
    }
  }

  public testSendEmail(typeSend: string) {
    const textContent = `
      <h2>Heading email</h2>
      <ul>
        <li>List 1</li>
        <li>List 2</li>
        <li>List 3</li>
      </ul>
      <p>
        <a href="https://www.gooogle.com">Link</a>
      </p>
      <p>
        <img
          style="margin: 0 auto; max-height: 80px; width: auto;"
          src="https://barcode.tec-it.com/barcode.ashx?data=123456&code=Code128&dpi=96&dataseparator=">
      </p>
    `;
    this.utilities.Alert.create({
      buttons: [{
        role: "cancel",
        text: "Cancel",
      }, {
        handler: (data) => {
          if (data.email) {
            const load = this.utilities.setLoading();
            this.emailData.sendEmail(
              this.form.get(typeSend).value[0],
              {
                email_button_label: "View app",
                email_button_redirect: "http://rebus.com.co",
                email_status: "TEST",
                email_text: textContent,
                email_title: "EXAMPLE TITLE",
              },
              [data.email],
              data.subject,
              this.form.get("from_email").value,
            ).subscribe((result) => {
              let message = "Email not sent, check the settings!";
              if (result) { message = "Email sent!"; }
              this.utilities.Toast.create({
                duration: 4000,
                message,
                position: "bottom",
              }).present().then(() => load.dismiss());
            });
          } else {
            this.utilities.Toast.create({
              duration: 2000,
              message: "Please enter email",
              position: "bottom",
            }).present();
            return false;
          }
        },
        text: "Send",
      }],
      inputs: [{
        name: "subject",
        placeholder: "Enter email subject",
        type: "text",
        value: "TEST SEND EMAIL REBUS",
      }, {
        name: "email",
        placeholder: "Enter email send",
        type: "email",
        value: this.userData.email,
      }],
      title: `Test send ${typeSend}`,
    }).present();
  }

  public onFormSubmitted({ value, valid }: { value: any; valid: boolean }) {
    this.submitAttempt = true;
    if (valid) {
      const load = this.utilities.setLoading();
      value.customer_commission = parseInt(value.customer_commission, 10);
      this.shopsData.createShop(this.clientId, value)
        .then(() => {
          this.utilities.Toast.create({
            duration: 3000,
            message: "The store was succesfully created",
          }).present();
          this.viewCtrl.dismiss().then(() => load.dismiss());
        });
    } else {
      this.utilities.setToast("The form contains errors, please check before continuing!");
      this.utilities.consoleError("Form", this.form);
    }
  }


  public setFormField(data: any = null) {
    const modal = this.utilities.Modal.create("ReserveFormFieldPage", { data }, { enableBackdropDismiss: false });
    modal.present();
    modal.onDidDismiss((result) => {
      if (result) {
        const currentData = this.form.get("formShopping").value;
        this.form.get("formShopping").setValue({
          ...currentData,
          [result.id]: { ...result },
        });
      }
    });
  }

  public existDataForm() {
    return Object.keys(this.form.get("formShopping").value).length > 0;
  }

  public clearItemObject(clearItem) {
    this.utilities.Alert.create({
      buttons: [{
        handler: () => {
          const current = this.form.get("formShopping").value;
          let data = {};
          Object.keys(current).forEach((k) => {
            if (clearItem.id !== k) {
              data = {
                ...data,
                [k]: { ...current[k], id: current[k].id },
              };
            }
          });
          this.form.get("formShopping").setValue(data);
        },
        text: "Confirm",
      }, {
        role: "cancel",
        text: "Cancel",
      }],
      message: "Are you sure to delete the item?",
      title: "Confirm",
    }).present();
  }

  private buildForm() {
    this.form = this.formBuilder.group({});
    this.genForm.genInputString("id", this.form);
    this.genForm.genInputString("name", this.form, true);
    this.genForm.genInputString("customer_commission", this.form, true, "0");
    // this.genForm.genInputJSON('shipping_list', this.form);
    this.genForm.genInputString("country", this.form, true, "3");
    this.genForm.genInputString("contacts_email", this.form, false);
    // this.genForm.genInputString("legal_documents", this.form, false);
    // this.genForm.genInputString("success_email", this.form, false);
    // this.genForm.genInputString("refunde_email", this.form, false);
    // this.genForm.genInputString("refuse_email", this.form, false);
    // this.genForm.genInputString("from_email", this.form, true);
    this.genForm.genToggle("isForm", this.form, false);
    this.genForm.genInputJSON("formShopping", this.form, false);
    this.genForm.genInputLang("formShoppingHeader", this.form, this.defaultLanguage, null, false);
    this.genForm.genToggle("state", this.form);
    this.patchForm();
    this.inspectFormValues();
  }

  private inspectFormValues() {
    this.form.get("isForm").valueChanges.subscribe((isForm) => {
      if (isForm) {
        this.form.get("formShopping").setValidators([JsonValidator.isJsonRequired]);
      } else {
        this.form.get("formShopping").clearValidators();
      }
      this.form.get("formShopping").updateValueAndValidity();
    });
  }

  private patchForm() {
    if (this.comerce) {
      this.form.patchValue(this.comerce);
    }
  }
}



// WEBPACK FOOTER //
// ./src/pages/shops/components/shops-form/shops-form.component.ts